<aside class="component w-auto h-full shadow-xl inline-flex p-[0.25rem]">
  <div class="h-full w-14 flex flex-col items-center justify-start gap-5 pt-2">
    <div class="w-full h-10 p-3 inline-flex items-center">
      <p-button
        (onClick)="toggleSidebar()"
        class="toggle-icon"
        [class.rotated]="sidebarWrapped()"
        [disabled]="sidebarWrapperDisabled()"
        icon="pi pi-chevron-left"
        severity="secondary"
        rounded
        size="small">
      </p-button>
    </div>
    <div class="h-full flex flex-col items-center justify-between">
      <div class="flex flex-col items-center gap-2 w-full h-full">
        @for (section of sidebarSections; track section.route) {
          <p-button
            (onClick)="navigateTo(section)"
            [icon]="section.icon"
            [severity]="isCurrentSection(section) ? 'primary' : 'secondary'"
            [outlined]="!isCurrentSection(section)"
            rounded
            [pTooltip]="section.label"
            tooltipPosition="right">
          </p-button>
        }
      </div>
      <div class="flex flex-col items-center gap-2 w-full h-auto mb-3">
        <p-button
          (onClick)="onLogout()"
          icon="pi pi-power-off"
          severity="danger"
          size="small"
          outlined
          rounded>
        </p-button>
        <p-overlay-badge [severity]="avatar() ? 'success' : 'warn'" class="inline-flex">
          @if (avatar(); as avatar) {
            <p-avatar
              [label]="avatar"
              shape="circle"/>
          } @else {
            <p-skeleton
              shape="circle"
              width="2rem"
              height="2rem"/>
          }
        </p-overlay-badge>
      </div>
    </div>
  </div>
  <div
    class="sidebar-content h-full w-46 flex flex-col items-center justify-start gap-5 pt-2"
    [class.collapsed]="sidebarWrapped()">
    <div class="w-42 h-10 p-2">
      <img src="logo/pw_emagazyn_logo.svg"
           alt="Parking Hub Logo"
           class="w-full h-8 object-contain">
    </div>
    <div class="size-full bg-surface-100 ring-1 ring-surface-200 rounded-[1.25rem] p-[0.4rem] flex flex-col gap-2">
      @for (item of activeMenuItems(); track item.route) {
        <p-button
          (onClick)="navigateTo(item)"
          [styleClass]="'w-full border-0 text-surface-500 ring-surface-100 text-sm inline-flex justify-start rounded-[0.85rem] h-10 hover:bg-surface-200'
          + (isRouteActive(item.route) ? ' bg-surface-0 ring-1 ring-surface-200 text-primary' : ' bg-surface-100 text-surface-500')">
          <i [class]="item.icon" pButtonIcon></i>
          <span class="whitespace-nowrap">{{ item.label }}</span>
        </p-button>
      }
    </div>
  </div>
</aside>
